// src/components/Footer.js
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        {/* Left Section */}
        <div className="footer-section left">
          <a href="#home">
            <img src="/Media/Logo/LogoFooter.png" alt="Logo" className="footer-logo" />
          </a>
          <p className="footer-description">
            The Center is spreading the true essence of yoga through its’ Trained, Qualified and Experienced yoga masters.
          </p>
          <div className="social-icons">
            <a href="http://wa.me/919999345631" target="_blank" rel="noopener noreferrer">
              <img src="/Media/Icons/whatsapp.gif" alt="WhatsApp" />
            </a>
            <a href="https://www.youtube.com/@yogyatrainstitute" target="_blank" rel="noopener noreferrer">
              <img src="/Media/Icons/youtube.png" alt="YouTube" />
            </a>
            <a href="https://www.instagram.com/yog_yatra_institute" target="_blank" rel="noopener noreferrer">
              <img src="/Media/Icons/instagram.png" alt="Instagram" />
            </a>
            <a href="https://www.facebook.com/p/Yog-Yatra-Institute-61556969956078/" target="_blank" rel="noopener noreferrer">
              <img src="/Media/Icons/facebook.png" alt="Facebook" />
            </a>
          </div>
        </div>

        {/* Middle Section */}
        <div className="footer-section middle">
          <h3>Regular Classes Time</h3>
          <div className="footer-item">
            <img src="/Media/Icons/Morning.png" alt="Morning" />
            <span>6:00 am - 9:00 am</span>
          </div>
          <div className="footer-item">
            <img src="/Media/Icons/Evening.png" alt="Evening" />
            <span>5:00 pm - 8:00 pm</span>
          </div>
          <div className="footer-item">
            <img src="/Media/Icons/Sunday.png" alt="Sunday" />
            <span>Holidays</span>
          </div>
        </div>

        {/* Right Section */}
        <div className="footer-section right">
          <h3>Contact Us</h3>
          <div className="footer-item">
            <img src="/Media/Icons/Call.png" alt="Call" />
            <span><a href="tel:+919999345631">+91-9999345631</a></span>
          </div>
          <div className="footer-item">
            <img src="/Media/Icons/Email.png" alt="Email" />
            <span><a href="mailto:yogyatrainstitute@gmail.com">yogyatrainstitute@gmail.com</a></span>
          </div>
          <div className="footer-item">
            <img src="/Media/Icons/location.png" alt="Location" />
            <span>
              <a href="https://www.google.com/maps?q=26.966136240783847,75.77728577800922" target="_blank" rel="noopener noreferrer">
                Sector 6, Vidyadhar Nagar, Jaipur, Rajasthan 302039
              </a>
            </span>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Yog Yatra Institute. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
